import SubmitButton from "../../../../components/SubmitButton/SubmitButton";
import "./NoOrdersDisplay.css";
import * as translator from "../../../../utils/translator";
import { useOutletContext } from "react-router-dom";

const NoOrdersDisplay = () => {
  const { language } = useOutletContext<any>();
  const openTreatmentTab = () => {
    const treatmentButton = document.querySelector(
      ".cms-header-navigation #header-treatments-icon"
    ) as HTMLButtonElement;
    treatmentButton.click();
  };
  return (
    <div className="no-orders-box">
      <span className="no-orders-text">
        {translator.translate(
          language,
          "my_account",
          "MyOrders/youHaveNoOrdersYet"
        )}
      </span>
      <SubmitButton
        id="no-orders-button"
        placeholder={translator.translate(
          language,
          "my_account",
          "MyOrders/browseCategories"
        )}
        onSubmit={openTreatmentTab}
      />
    </div>
  );
};

export default NoOrdersDisplay;
